import React from 'react';

const HomeEditBannerTwo = ({ themeData }: any) => {
  return (
    <section
      className="aboutsec"
      style={{
        background: `#${themeData?.theme_5?.home?.section_6?.background_image_color} url("assets/img/about-section/about-bg.png") no-repeat`,
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 d-none d-md-block">
            <div className="about-img-left aos-init" data-aos="zoom-in-up" style={themeData?.theme_5?.home?.section_6?.section_image && {background: `url(${themeData?.theme_5?.home?.section_6?.section_image})`}}>
              {/* {themeData?.theme_5?.home?.section_6?.section_image && (
                <img
                  src={themeData?.theme_5?.home?.section_6?.section_image}
                  className="img-fluid aos-init"
                  alt="About US"
                  data-aos="zoom-in-up"
                />
              )} */}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content-right aos-init" data-aos="zoom-in-up">
              <div className="section-title">
                <h2
                  className="text-start section-title-h2"
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_6?.h2color}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_6?.title}
                </h2>
                <h2
                  className="section-title-head"
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_6?.h3color}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_6?.sub_heading}
                </h2>
              </div>

              <p
                style={{
                  color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                }}
              >
                {themeData?.theme_5?.home?.section_6?.paragraph}
              </p>
              <div className="about-icon">
                <div className="row">
                  {themeData?.theme_5?.home?.section_6?.card_section.collection.map(
                    (item: any) => {
                      return (
                        <>
                          <div className="col-lg-6 col-md-6">
                            <div className="media d-flex">
                              {item.collection_image && (
                                <img
                                  src={item.collection_image}
                                  alt="About Icon"
                                />
                              )}
                              <div className="media-body flex-grow-1">
                                <h5
                                  style={{
                                    color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                                  }}
                                >
                                  {item.collection_title}
                                </h5>
                                <p
                                  style={{
                                    color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                                  }}
                                >
                                  {item.collection_paragraph}
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeEditBannerTwo;
